import { render, staticRenderFns } from "./inbounds.vue?vue&type=template&id=35a35882&scoped=true&"
import script from "./inbounds.vue?vue&type=script&lang=js&"
export * from "./inbounds.vue?vue&type=script&lang=js&"
import style0 from "./inbounds.vue?vue&type=style&index=0&id=35a35882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a35882",
  null
  
)

export default component.exports